import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ContactPersonForm.html?raw';
import "../ContactPersonForm/ContactPersonForm";
import { AddressWizardTypes, AddressClassnames } from "../AddressWizardTypes";

import _StatefulBase from '../../../moreCore/UI/_StatefulBase/_StatefulBase';
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import '../../../moreCore/UI/DateInput/DateInput';

import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import '../../../moreCore/UI/SelectBox/SelectBox';

import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';

import Button from '../../../moreCore/UI/Button/Button';
import '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/PhoneInput/PhoneInput';
import '../../../moreCore/UI/NumberInput/NumberInput';
import '../../../moreCore/UI/CheckBox/CheckBox';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import "../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox"
import { ExpandableSectionMarkings, ExpandableSection, HTMLElementWithExpander } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import _LabelInputBase from '../../../moreCore/UI/_LabelInputBase/_LabelInputBase';
import { OMtypes } from "../../_loadingHelpers/OM";

import musicianContractForm from '../OMcontract/OMmusicianContractForm';
import OMmusicianContractForm from '../OMcontract/OMmusicianContractForm';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import contactDisplayTable from '../ContactAndCommunication/contactDisplayTable';
import communicationEditor from '../ContactAndCommunication/communicationEditor';
import GDPRSection from '../GDPR/GDPRSection';

interface TelecomReg {
    input: MdsLax<InstanceType<ReturnType<typeof _LabelInputBase>>>;
    node: HTMLElement;
    entityID?: any
    deleted?: boolean
}

class ContactPersonForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private sectionActiveContract: HTMLElement;
    private sectionInactiveContracts: HTMLElement;
    private inactiveContractsContainer: HTMLElement;
    private activeContractContainer: HTMLElement;
    private createContractContainer: HTMLElement;

    private allValues: Partial<AddressWizardTypes.ContactPersonEntity & AddressWizardTypes.ContactPersonFormData> = {};
    private mandatoryFields: Array<string> = ['organisation'];

    private ContactDataForm: HTMLDivElement;
    //private AdditionalContactDataFieldsRight: HTMLDivElement;
    //private AdditionalContactDataFieldsLeft: HTMLDivElement;
    private telecomContainer: HTMLElement;
    //contactFields: SelectBox;
    //private contactDataFields: {
    //    "mobile": Array<TelecomReg>,
    //    "phone": Array<TelecomReg>,
    //    "messenger": Array<TelecomReg>,
    //    "webphone": Array<TelecomReg>,
    //    "fax": Array<TelecomReg>,
    //    "mail": Array<TelecomReg>,
    //    "web": Array<TelecomReg>
    //} = {
    //        fax: [],
    //        mail: [],
    //        messenger: [],
    //        mobile: [],
    //        phone: [],
    //        webphone: [],
    //        web: []
    //    };
    //private additionalContactFieldsCounter: number = 1;
    //private addContactFieldButton: HTMLButtonElement;

    private contactPersonTable: HTMLTableElement;
    private addressCategoryTable: HTMLTableElement;

    private addressCategory: MdsLax<InstanceType<typeof MultiselectBox>>;
    private organisation: MdsLax<InstanceType<typeof HintBox>>;
    private jobTitle: MdsLax<InstanceType<typeof HintBox>>;
    private division: MdsLax<InstanceType<typeof SelectBox>>;
    private divisionContainer: HTMLElement;
    private divisionPresetValue: any = null;

    private activeContractForm: MdsLax<InstanceType<typeof musicianContractForm>>;
    private musicianContractFormHeading: HTMLHeadingElement;
    private sectionMusicianData: HTMLDivElement;
    private MusicianDataExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private inactiveContractsExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    //private isMusicianCheckBox: CheckBox;
    //private functionalSubGroup: SearchSelect;
    //private serviceObligation: NumberInput;
    //private musicianContractType: SearchSelect;
    //private contractStartDate: DateInput;
    //private contractEndDate: DateInput;
    //private profession: HintBox;
    //private functionalSubGroupTable: HTMLTableElement;
    //private professionsTable: HTMLTableElement;
    //private addFunctionalSubGroupButton: HTMLButtonElement;
    //private addProfessionButton: HTMLButtonElement;

    callback: Function;
    private saveBtnContainer: HTMLElement

    private _originalValues: string = "";
    private entity: AddressWizardTypes.ContactPersonEntity;

    private _loadState: "loading" | "ready" = "ready";

    private inactiveContractsStore: MdsLax<InstanceType<typeof EntityStore<any>>>;

    private entityId: string;
    private sectionTelecom: MdsLax<InstanceType<typeof ExpandableSection>>;
    private contactWidgetContainer: HTMLElement;
    private contactAndCommunicationTable: MdsLax<InstanceType<typeof contactDisplayTable>>;

    private language: MdsLax<InstanceType<typeof SelectBox>>;
    private languageSelectContainer: HTMLElement;

    private GDPRSectionExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private GDPRSectionWidgetContainer: HTMLDivElement;
    private GDPRSectionWidget: MdsLax<InstanceType<typeof GDPRSection>>;
    private GDPRSectionChangedData: Object = null;
    private _GDPRSectionTimeoutHandler: any = null;

    /**
     * Setup für ein NEUE Kontaktperson. (Für bestehende: setValues verwenden)
     * @param targetAddressID ID der bestehenden Basis-Adresse, der eine neue Organisation zugewiesen werden soll
     * @param organisationsAlreadyInUse Bereits zugewiesene Organisations-IDs, die nicht mehr ausgewählt werden dürfen
     */
    setup(targetAddressID?: string, organisationsAlreadyInUse?: Array<string>) {
        this.startup();

        this.organisation.setJsonRequestFormat();

        if (organisationsAlreadyInUse) this.organisation.addRequestProperty("excludeResultIDs", organisationsAlreadyInUse);
        if (targetAddressID) this.organisation.addAdditionalRequestParameter("targetAddressID", targetAddressID);

        this._setupContracts([]);


        this.hideNode(this.saveBtnContainer, typeof (this.callback) != "function");

    }

    /**
     * Readonly Organization bei neue Ansprechpartner/Mitarbeiter aus Organization Kontext
     */
    setDefaultOrganization(organization: AddressWizardTypes.AddressEntity) {

        this.organisation.setValue(organization);
        this.organisation.setReadonly(true);
    }

    setValues(entity: AddressWizardTypes.ContactPersonEntity) {
        console.log(this.id + " setValues", entity);
        this._loadState = "loading";
        this.allValues.ID = entity.ID;
        this.entity = entity;
        this.entityId = entity.ID;

        if (entity.ref_division) this.divisionPresetValue = entity.ref_division["ID"];

        if (this.hasFeature("AddressWizard/LanguageSelect")) this.language.setValue(entity.ref_language?.ID);

        if (entity.ref_organisation) {
            this.UiModder.domClass.add(this.organisation.domNode, "w3-disabled");
            this.organisation.valueChangeEmitterDelay = 1;
            this.organisation.setValue(entity.ref_organisation);
            this.organisation.valueChangeEmitterDelay = 100;
        }
        if (entity.ref_job_title) {
            // Race condition: weil das change-event von organisation noch daherkommt irgendwann.
            setTimeout(lang.hitch(this.jobTitle, "setValue", entity.ref_job_title), 10);
            //this.jobTitle.setValue(entity.ref_job_title);

        } else if (entity.c_job_title) {
            setTimeout(lang.hitch(this.jobTitle, "setValue", entity.c_job_title), 10);
        }

        // ist es ein Mitarbeiter? casten und prüfen ob es die Verträge als Liste gibt:
        let associateEntity: AddressWizardTypes.AssociateEntity = entity as AddressWizardTypes.AssociateEntity;
        this._setupContracts(associateEntity.EL_vt_internal_contract_md_associate);



        //this.UiModder.domConstruct.empty(this.telecomContainer);
        //this.additionalContactFieldsCounter = 1; // reset to start
        //// Registry zurücksetzen:
        //this.contactDataFields = {
        //    fax: [],
        //    mail: [],
        //    messenger: [],
        //    mobile: [],
        //    phone: [],
        //    web: [],
        //    webphone: []
        //}

        //if (entity.EL_vt_telecommunications_adress?.length > 0) {
        //    entity.EL_vt_telecommunications_adress.forEach(lang.hitch(this, this._addContactFields))
        //}
        if (entity.EL_ht_address_adresscategory_address?.length > 0) {
            let values: Array<string> = [];
            for (let htCategory of entity.EL_ht_address_adresscategory_address) {
                values.push(htCategory.ref_address_category.ID);
            }

            this.addressCategory.setValue(values, true);
            this.allValues["addressCategory"] = values;
        }


        this.getValues();

        this._loadState = "ready";

        this.load_SetContactTableContext();
        this._loadGDPRSection();
    }

    close() {
        this.emit("close");
    }

    getValues() {
        //Need to call here in case of plain text value becaus it does not trigger change event
        this._onValueChange_jobTitle()

        if (!this.organisation.validateInput()) return;

        let currentValuesTxt = JSON.stringify(this.allValues);
        if (!this._originalValues) {
            this._originalValues = currentValuesTxt;
        }

        this.allValues.hasChanged = this._originalValues != currentValuesTxt;
        return this.allValues;
    }

    private _setupContracts(contracts: Array<OMtypes.musicianContract>) {

        let activeContracts = [];
        let inactiveContracts = [];
        //for (let contract of contracts) {
        //    if (contract.is_active == true) {
        //        activeContracts.push(contract);
        //    } else {
        //        inactiveContracts.push(contract);
        //    }
        //}
        contracts?.forEach(contract => {

            if (contract.is_active == true) {
                activeContracts.push(contract);
            } else {
                inactiveContracts.push(contract);
            }
        })

        this.inactiveContractsStore = new EntityStore();
        this.inactiveContractsStore.on("change", lang.hitch(this, this._onChangeInactiveContracts));

        this.hideNode(this.sectionActiveContract, activeContracts.length == 0);
        this.hideNode(this.sectionInactiveContracts, inactiveContracts.length == 0);

        this.MusicianDataExpander.setMarking(activeContracts.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
        this.inactiveContractsExpander.setMarking(inactiveContracts.length == 0 ? ExpandableSectionMarkings.hidden : ExpandableSectionMarkings.default);

        //this.isMusicianCheckBox.setValue(activeContracts.length > 0);

        for (let contract of activeContracts) {
            let form = new OMmusicianContractForm();
            form.setup(contract);

            form.placeAt(this.activeContractContainer, "only");
            form.startup();
            form.on("change", lang.hitch(this, this.addContractValues, "changed"));

            this.activeContractForm = form;

            break;
        }

        if (inactiveContracts.length > 0) {
            this.inactiveContractsStore.setup(inactiveContracts);
        }

        this._setupInactiveContractsTable();
    }

    private _onClick_CreateContract(evt: MouseEvent) {

        if (!this.hasOMprivileges) return;

        this.createNewContract();
    }

    private createNewContract() {

        this.hideNode(this.sectionActiveContract, false);
        this.hideNode(this.createContractContainer);

        if (this.activeContractForm) {
            let currentActiveEntity = this.activeContractForm.getValues();

            this.inactiveContractsStore.addEntry(currentActiveEntity as any, "changed");
            this.inactiveContractsStore.setEntityAttributeValue(currentActiveEntity.ID, "is_active", false);

            this.hideNode(this.sectionInactiveContracts, false);
            this.inactiveContractsExpander.setMarking(ExpandableSectionMarkings.default);


            this.hideNode(this.activeContractForm.domNode);
        //    this.UiModder.domClass.add(this.activeContractForm.domNode, "mds-fade");
        //    setTimeout(lang.hitch(this, function () { this.UiModder.domClass.add(this.activeContractForm.domNode, "hidden"); }), 10);
        }

        this.UiModder.domAttr.set(this.musicianContractFormHeading, "innerHTML", this.translate("AddressWizard_OM__NewMusicianContractHeading"));

        let newForm = new OMmusicianContractForm();
        newForm.placeAt(this.activeContractContainer, "first");
        newForm.startup();
        newForm.on("change", lang.hitch(this, this.addContractValues, "new"));

        this.MusicianDataExpander.setMarking(ExpandableSectionMarkings.hasContent);


        setTimeout(lang.hitch(this, function (newForm) {
            if (this.activeContractForm) this.activeContractForm.destroy();
            this.activeContractForm = newForm;
        }, newForm), 200);
    }

    private _onChangeInactiveContracts() {
        this._setupInactiveContractsTable();

        this.addContractValues();
    }

    private _setupInactiveContractsTable() {
        let inactiveContracts = this.inactiveContractsStore?.getCurrentCompleteList() as Array<OMtypes.musicianContract>;

        if (inactiveContracts?.length > 0) {
            let tableLayout: StaticTable.RowConfig = {
                colNamesInternal: ["active", "template", "contractType", "validFrom", "validUntil"],
                attributes: ["is_active", "is_dummy", "ref_musican_contract_type.description", "date_valid_from", "date_valid_until"],
                headings: [this.translate("General_Label_IsActive"), this.translate("General_Label_Template"),this.translate("General_Label_ContractType"), this.translate("General_Label_ValidFrom"), this.translate("General_Label_ValidUntil")],
                widths: ["10ch", "10ch"]
            };

            this.UiModder.domConstruct.empty(this.inactiveContractsContainer);

            let table = new StaticTable();
            table.addLineConfig(tableLayout);
            table.setFormatter(lang.hitch(this, this._contractsTableFormatter));
            table.setCyAttribute("contactPerson");

            if (this.hasUserRole("OM_MusicianData_Edit")) {
                table.addDefaultRowActionButton("edit");
                table.on("edit", lang.hitch(this, this._onClickEditMusicianContract));
                table.setRowClick(lang.hitch(this, this._onClick_InactiveMusicianContractRow))
            }

            if (this.hasUserRole("OM_MusicianData_Delete")) {
                table.addDefaultRowActionButton("delete");
            }


            table.setupFromStore(this.inactiveContractsStore);
            table.placeAt(this.inactiveContractsContainer);


        }
    }
    private _contractsTableFormatter(cell: StaticTable.StaticTableCell<OMtypes.musicianContract>) {
        let row = cell.tableRow;
        let entity = cell.entity;

        switch (cell.name) {
            case "active":
                this.UiModder.domClass.toggle(row.node, "w3-opacity", entity.is_active != true);
                this.UiModder.domClass.toggle(row.node, "w3-text-blue", entity.is_dummy === true);
                break;
        }

        return false;
    }
    private _onClick_InactiveMusicianContractRow(row, rowgroup: StaticTable.StaticTableRowGroup<OMtypes.musicianContract>) {
        this._onClickEditMusicianContract(rowgroup);
    }
    private _onClickEditMusicianContract(rowgroup: StaticTable.StaticTableRowGroup<OMtypes.musicianContract>) {
        let entity = rowgroup.entity;
        //console.log("_onEditMusicianContract", entity);
        this.editMusicianContract(entity);
    }

    private editMusicianContract(entity: OMtypes.musicianContract) {
        if (entity && this.hasUserRole("OM_MusicianData_Edit")) {

            let form = new musicianContractForm();
            form.setup(entity);

            let dlg = new GenericDialog();

            dlg.show(form,
                this.translate("AddressWizard_OM__EditMusicianContract"),
                null,
                null,
                "okcancel",
                lang.hitch(this, this._onEditMusicianContractCallback, form));

            form.startup();
        }
    }

    private _onEditMusicianContractCallback(form: MdsLax<InstanceType<typeof musicianContractForm>>, result: number) {
        if (result <= 0) return;

        this.inactiveContractsStore.changeEntry(form.getValues());
    }

    //_addContactFields(data: AddressWizardTypes.Telecommunication) {
    //    switch (data.Classname) {
    //        case "messenger_addresses":
    //            this.addContactDataField("messenger", data.telecom_code, data.ID)
    //            break;
    //        case "email_addresses":
    //            this.addContactDataField("mail", data.telecom_code, data.ID)
    //            break;
    //        case "phone_numbers":
    //            this.addContactDataField("phone", data.telecom_code, data.ID)
    //            break;
    //        case "mobilephone_numbers":
    //            this.addContactDataField("mobile", data.telecom_code, data.ID)
    //            break;
    //        case "fax_addresses":
    //            this.addContactDataField("fax", data.telecom_code, data.ID)
    //            break;
    //        case "webphone_addresses":
    //            this.addContactDataField("webphone", data.telecom_code, data.ID)
    //            break;
    //        case "web_addresses":
    //            this.addContactDataField("web", data.telecom_code, data.ID)
    //            break;
    //    }

    //}

    private updateDivisionList(id): void {

        if (!this.hasFeature("Address/DivisionsSection")) return;
        this.allValues.ref_division = null;

        var url = window.appRoot + "AddressWizard/GetDivisionsInOrganizationList";
        this.division.StandbyStart()

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify({ divisionId: null, organizationId: id })
            },
            (response: any) => {
                this.division.StandbyStop();
                this.division.setBlankOption("", "-- --", true);
                this.division.setData(this.divisionPresetValue,
                    response,
                    "ID",
                    "name",
                    false
                );

                this.division.constructOptions();
            },
            (err:any) => { alert(err.Message) },
            false // sync
        );
    }

    private _onChange_language(): void {

        this.allValues.ref_language = this.language.getValue();
    }

    private _onValueChange_division(): void {

        this.allValues.ref_division = this.division.getValue();
    }

    private _onValueChange_organisation(value: AddressWizardTypes.Organisation) {

        this.hideNode(this.MusicianDataExpander,
            !this.hasOMprivileges ||
            !(value?.Classname == AddressClassnames.organisations_internal));

        if (value?.Classname == AddressClassnames.organisations_internal) {
            this.allValues.type = "contactPerson";
            this.allValues.contactPersonType = this.translations["AddressWizard__ContactPerson"];
        } else if (value?.Classname == AddressClassnames.organisations_external) {
            this.allValues.type = "contactPerson";
            this.allValues.contactPersonType = this.translations["AddressWizard__Associate"];

            if (this.activeContractForm) {
                this.activeContractForm.destroy();
                this.addContractValues();
            }
        }

        this.jobTitle.setValue(null);
        this.jobTitle.addAdditionalRequestParameter("organisationID", value?.ID);
        this.jobTitle.setReadonly(value ? false : true);


        this.addValue(this.organisation);
        this.allValues.ref_organisation = value;

        this.updateDivisionList(value?.ID);

        this.emit("changeOrganisation", value);
    }

    _onValueChange_jobTitle() {
        this.addValue(this.jobTitle);
        this.allValues.ref_job_title = this.jobTitle.getValue("entity");
        if (!this.allValues.ref_job_title) this.allValues.c_job_title = this.jobTitle.getValue("value");
        console.log(this.allValues.c_job_title);
        console.log(this.allValues.ref_job_title);
    }

    //_onValueChange_contactField(value) {
    //    this.UiModder.domClass.toggle(this.addContactFieldButton, "w3-disabled", value == null)
    //}

    private _onChange_addressCategory() {
        this.addValue(this.addressCategory);
    }


    //private _onClick_AddContactDataField_Button(evt?) {
    //    console.debug("_onClick_AddContactDataField_Button", evt);
    //    if (evt && evt.target?.dataset?.fieldtype) {
    //        this.addContactDataField(evt.target.dataset.fieldtype);
    //        return;
    //    }

    //    this.addContactDataField();
    //}

    //private addContactDataField(fieldTypeParam?: "mobile" | "phone" | "messenger" | "web" | "webphone" | "fax" | "mail", value: string = null, ID?: string) {
    //    let fieldType = fieldTypeParam ? fieldTypeParam : null;// this.contactFields.getValue();
    //    let input: _LabelInputBase = null;
    //    let fieldName: string = null;
    //    let targetContainer = null;
    //    let label = null;

    //    switch (fieldType) {
    //        case "mobile":
    //        case "phone":
    //            input = new PhoneInput();
    //            break;
    //        case "messenger":
    //        case "webphone":
    //        case "web":
    //        case "fax":
    //        case "mail":
    //            input = new Edit();
    //            if (fieldType == "mail") {
    //                (input as Edit).pattern = "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
    //            }
    //            break;

    //        default: return;
    //            break;
    //    }


    //    input.setLabel(label)
    //    if (value != "") {
    //        input.setValue(value);
    //    }

    //    input.validationEnabled = true;

    //    //if (this.additionalContactFieldsCounter % 2 == 0) {
    //    //    targetContainer = this.UiModder.domConstruct.create("div", { className: "flex_row_bottom nowrap w3-margin-bottom" }, this.AdditionalContactDataFieldsRight)
    //    //} else {
    //    //    targetContainer = this.UiModder.domConstruct.create("div", { className: "flex_row_bottom nowrap w3-margin-bottom" }, this.AdditionalContactDataFieldsLeft)
    //    //}
    //    targetContainer = this.UiModder.domConstruct.create("div", { className: "flex_row_bottom flex_cell_half nowrap" }, this.telecomContainer);


    //    let reg: TelecomReg = {
    //        input: input,
    //        node: targetContainer,
    //        entityID: ID,
    //        deleted: false
    //    }

    //    on(input, "change", lang.hitch(this, this.addContactFieldValue, reg, fieldType, ID))


    //    if (!this.contactDataFields[fieldType]) {
    //        console.warn("missing array for telecom??", fieldType, this.contactDataFields);
    //        this.contactDataFields[fieldType] = [];
    //    }
    //    this.contactDataFields[fieldType].push(reg);

    //    fieldName = fieldType + "_" + (ID ? ID : (Math.random() * 1000000).toFixed(0));

    //    this.UiModder.domAttr.set(input.domNode, "name", fieldName);

    //    this.UiModder.domAttr.set(input.domNode, "type", fieldType);
    //    this.UiModder.domAttr.set(input.domNode, "data-entityId", ID);
    //    this.UiModder.domClass.add(input.domNode, "flex_cell_threequarter");


    //    input.placeAt(targetContainer)

    //    let btnRemove = new Button();
    //    btnRemove.on("click", lang.hitch(this, this._onClick_removeContactField, reg));
    //    btnRemove.setLabel("");
    //    btnRemove.setIconLeft("fas fa-trash");
    //    btnRemove.setClasses("warning hoverBright");
    //    this.UiModder.domClass.add(btnRemove.domNode, "paddingSmall");

    //    btnRemove.placeAt(targetContainer);

    //    this.additionalContactFieldsCounter++;

    //    this._updateTelecomLabels();
    //}

    //private _updateTelecomLabels() {
    //    let totalCount = 0;
    //    for (let type in this.contactDataFields) {
    //        let entries: Array<TelecomReg> = this.contactDataFields[type];

    //        let iconClass = "";
    //        switch (type) {
    //            case "mobile":
    //                iconClass = "fas fa-mobile secondaryTXT";
    //                break;
    //            case "web":
    //                iconClass = "fas fa-globe secondaryTXT";
    //                break;
    //            case "webphone":
    //                iconClass = "fas fa-headset secondaryTXT";
    //                break;
    //            case "phone":
    //                iconClass = "fas fa-phone secondaryTXT";
    //                break;
    //            case "mail":
    //                iconClass = "fas fa-at secondaryTXT";
    //                break;
    //            case "fax":
    //                iconClass = "fas fa-fax secondaryTXT";
    //                break;
    //            case "messenger":
    //                iconClass = "fas fa-comment secondaryTXT";
    //                break;
    //        }

    //        let counter = 0;
    //        for (let entry of entries) {
    //            if (entry.deleted != true) {
    //                counter++;
    //                totalCount++;
    //                let icon = this.createFontawesomeIcon(iconClass, "&nbsp;");
    //                let label = icon.outerHTML + this.translate("AddressWizard__" + type) + " " + counter;
    //                entry.input.setLabel(label);

    //            }
    //        }
    //    }
    //}

    private addContactFieldValue(regEntry: TelecomReg, fieldType: string, ID?: string): void {

        let input: MdsLax<InstanceType<typeof _StatefulBase>> = regEntry.input;

        let widgetName: string = this.UiModder.domAttr.get(input.domNode, "name");

        if (input.getValue() && input.validateInput()) {


            let widgetValue: any = input.getValue();

            if (!this.allValues[fieldType]) {
                this.allValues[fieldType] = [];
            }
            //this.allValues[fieldType][widgetName] = { value: widgetValue };

            let obj = this.allValues[fieldType].find(data => data.fieldName == widgetName);
            if (obj) {
                obj.value = widgetValue
            } else {
                this.allValues[fieldType].push({ fieldName: widgetName, value: widgetValue, ID: ID })
            }


        } else {
            if (this.allValues[fieldType]) {
                //delete this.allValues[fieldType][widgetName];
                this.allValues[fieldType] = this.allValues[fieldType].filter(data => data.fieldName != widgetName);
            }
        }

        this.checkSectionContents();
    }

    //private _onClick_removeContactField(registry: TelecomReg) {

    //    let input = registry.input;
    //    registry.deleted = true;

    //    let fieldName = this.UiModder.domAttr.get(input.domNode, "name");
    //    let fieldType = this.UiModder.domAttr.get(input.domNode, "type");

    //    //this.contactDataFields[fieldType] = this.contactDataFields[fieldType].filter(data => data != fieldName);
    //    //delete this.allValues[fieldType][fieldName];
    //    //this.allValues[fieldType][fieldName] = "";
    //    if (this.allValues[fieldType]) {
    //        this.allValues[fieldType] = this.allValues[fieldType].filter(data => data.fieldName != fieldName);
    //    }

    //    /*
    //    if (this.allValues[fieldType].length == 0) {
    //        delete this.allValues[fieldType];
    //    }
    //    */

    //    this.UiModder.domConstruct.destroy(input.domNode.parentNode);
    //    this.additionalContactFieldsCounter--;

    //    this._updateTelecomLabels();

    //}


    private _onClick_Save() {
        if (this.allValues["contactPerson"]) {
            this.allValues["contactPerson"].forEach(data => delete data["form"]);
        }

        let flag = true;

        for (let i = 0; i < this.mandatoryFields.length; i++) {
            this[this.mandatoryFields[i]].setMandatory(true);
            this[this.mandatoryFields[i]].validateInput()
            if (!this[this.mandatoryFields[i]].validateInput()) {
                flag = false
                this[this.mandatoryFields[i]]["domNode"].scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }

        if (flag && this.allValues) {
            this.callback(this.getValues());
        }

    }

    private addContractValues(targetOfActiveContract?: "new" | "changed") {

        let org: AddressWizardTypes.Organisation = this.organisation.getValue("entity");

        if (!this.hasOMprivileges || org?.Classname != AddressClassnames.organisations_internal) {
            if (this.allValues["OMmusicianContracts"]) delete this.allValues["OMmusicianContracts"];
        } else {
            let currentContractData = this.activeContractForm?.getValues();

            //if (targetOfActiveContract == "new") {
            //    this.inactiveContractsStore.addEntry(currentContractData, "new");
            //} else if (targetOfActiveContract == "changed") {
            //    this.inactiveContractsStore.addEntry(currentContractData, "changed");
            //}

            let storeData = this.inactiveContractsStore.getDiffData();
            if (targetOfActiveContract == "new") {
                storeData.new.push(currentContractData);
            }
            else if (targetOfActiveContract == "changed") {
                storeData.changed.unshift(currentContractData); // unshift fügt das Element VORNE ins Array ein
            }

            this.allValues["OMmusicianContracts"] = storeData;
            //{
            //    activeContract: currentContractData,
            //    inactiveContracts: this.inactiveContractsStore.getDiffData()
            //}
            console.log("changed contract values", this.allValues["OMmusicianContracts"]);
        }

    }

    addValue(input: MdsLax<InstanceType<typeof _StatefulBase>>): void {
        let widgetName: string = typeof this.getAttachPointNameForWidget(input) == "undefined"
            ? this.UiModder.domAttr.get(input.domNode, "name")
            : this.getAttachPointNameForWidget(input);
        if (input.getValue() && input.validateInput()) {

            let widgetValue: any = input.getValue();

            if (input == this.jobTitle) {
                //let disp = this.jobTitle.getDisplayValue();
                //let value = widgetValue;

                widgetValue = this.jobTitle.getValue("entity"); // { "ID": value, value: disp };
            }

            this.allValues[widgetName] = widgetValue;
        } else {
            delete this.allValues[widgetName];
        }

        console.debug("addValue - contactpersonform", this.allValues);

        this.checkSectionContents();

    }
    addDateValue(input: MdsLax<InstanceType<typeof DateInput>>): void {

        if (input.validateInput()) {
            this.allValues[this.getAttachPointNameForWidget(input)] = input.toStringISO(input.getValue()).substr(0, 10);
        } else {
            delete this.allValues[this.getAttachPointNameForWidget(input)];
        }

    }
    getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }
    _editCaseCamel(value: string, eachWord: boolean = true): string {

        value = value.trim();

        if (value.length != 17 && value.indexOf(":") != 8) { // wenn das keine id ist
            let words: Array<string> = value.split(" ");
            let camelCasedWords: Array<string> = [];
            if (words && words.length && eachWord === true) {
                for (let word of words) {
                    let lowerCale: string = word.slice(1).toLowerCase();
                    let firstCase: string = word.slice(0, 1).toUpperCase();
                    camelCasedWords.push(firstCase + lowerCale);
                }

                return camelCasedWords.join(" ");
            } else {
                let lowerCale: string = value.slice(1).toLowerCase();
                let firstCase: string = value.slice(0, 1).toUpperCase();

                return firstCase + lowerCale;
            }
        } else {
            // sont unmodifiziert zurück geben
            return value;
        }
    }

    _createTable(table: HTMLTableElement, data: Array<any>) {
        let fields = Object.keys(data[0]);
        console.log(table);
        this.UiModder.domConstruct.empty(table);
        let tr = table.insertRow();
        fields.forEach(lang.hitch(this, this._addTableHeads, tr))
        data.forEach(lang.hitch(this, this._createTableRows, table, fields))
    }

    _addTableHeads(tableRow: HTMLTableRowElement, field: string) {
        if (field != "type") {
            this.UiModder.domConstruct.create("th", { "innerHTML": "<b>" + this.translations["AddressWizard__" + field] + "</b>" }, tableRow)
        }
    }

    _createTableRows(table, fields, data) {
        let tr = table.insertRow();
        fields.forEach(lang.hitch(this, this._createTableCell, data, tr))

        let btnRemove = new Button();
        btnRemove._onClick_Button = lang.hitch(this, this._removeTableRow, tr, data, table);
        btnRemove.setLabel("");
        btnRemove.setIconLeft("fas fa-trash warningTXT");
        btnRemove.setClasses("hoverBright w3-small deleteBtn");
        this.UiModder.domStyle.set(btnRemove.domNode, "float", "left");

        let td = this.UiModder.domConstruct.create('td')
        btnRemove.placeAt(td);
        this.UiModder.domConstruct.create(td, { "style": "float: right" }, tr);

    }

    _createTableCell(data, tr, field) {
        if (field != "type") {
            let value = typeof data[field] == "object" ? data[field]["value"] : data[field];
            this.UiModder.domConstruct.create('td', {
                "innerHTML": value ? value : ""
            }, tr)
        }
    }

    _removeTableRow(tr, data, table: HTMLTableElement) {
        this.UiModder.domConstruct.destroy(tr);
        if (table.rows.length == 1) {
            this.UiModder.domConstruct.empty(table);
        }
        this.allValues[data.type] = this.allValues[data.type].filter(row => row != data);
        this.emit("tableRowRemoved");
    }



    private _onValueChange_isMusicianCheckBox(value) {
        //if (value) this.MusicianDataExpander.toggleExpand(true);
        //this.addValue(this.isMusicianCheckBox);
    }

    //private _onDisplayProfessionSED(evt: MouseEvent) {
    //    let dlg = new SelectEntityDialog();
    //    dlg.setup(
    //        "profession",
    //        lang.hitch(this, this._onSelectSEDprofession),
    //        "AddressWizard/GetProfessionList",
    //        15,
    //        null,
    //        null,
    //        "description");

    //    dlg.show();
    //}

    //private _onSelectSEDprofession(values: Array<string>, items: Array<SelectEntityDialogTypes.Item>) {
    //    if (values && values.length) {
    //        this.profession.setValue(items[0].entry.data);
    //    }
    //}


    private _onCommTableContentChange(): void {
        if (!this._originalValues) {
            this._originalValues = JSON.stringify(this.allValues);
        }

        this.allValues.teleCommData = this.contactAndCommunicationTable.getContactRegestry();

        this.checkSectionContents();
    }
    private checkSectionContents() {

        if (this.contactAndCommunicationTable) {
            this.sectionTelecom.setMarking(this.contactAndCommunicationTable.hasEntries() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }
    }

    private hasOMprivileges: boolean = false;
    private _handlePrivileges() {
        this.hasOMprivileges = this.hasUserRole(["OM", "OM_AddressWizard_MusicianData"]);
        this.hideNode(this.sectionMusicianData, !this.hasOMprivileges);

        this.hideNode(this.createContractContainer, !this.hasUserRole("OM_MusicianData_Create"));

    }


    private _onRequest_CommunicationEditor(editorWidget: MdsLax<InstanceType<typeof communicationEditor>>) {
        //let tabConf = editorWidget.getTabConfig();
        //tabConf.targetContainerName = this.getTabContainerName();
        //this.createNewTabbedContent(tabConf, true, false);
        editorWidget.init(this.getTabContainerName());
    }
    private _onSaved_UpdateContactCommunicationData() {
        this.contactAndCommunicationTable.updateData();
    }

    private flagContactCommunicationContextWasSet = false;
    private load_SetContactTableContext() {

        if (this.flagContactCommunicationContextWasSet == false) {
            this.flagContactCommunicationContextWasSet = true;
            this.contactAndCommunicationTable.setAddressContext(this.entityId, this.entity?.ref_country);
        }
    }

    private _getLanguages() {
        if (!this.hasFeature("AddressWizard/LanguageSelect")) return;
        this.hideNode(this.languageSelectContainer, false);

        this.hourGlassStart(this.language);

        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_GetLanguagesData",
            {},
            lang.hitch(this, this._onLoadLanguagesResponse),
            (err) => {
                alert("ERROR beim _onLoadLanguagesError: " + err.Message);
                this.hourGlassEnd(this.language);
            },
            false // sync
        );
    }
    private _onLoadLanguagesResponse(response) {
        let preset = this.language.getValue();
        this._processSelectBoxValues(this.language, response);
        if (preset) this.language.setValue(preset);
        this.hourGlassEnd(this.language);
    }
    private _processSelectBoxValues(selectBox: MdsLax<InstanceType<typeof SelectBox>>, items, field = "description") {
        for (let entity of items) {
            selectBox.addOption(entity.ID, entity[field], true);
        }
        selectBox.constructOptions();

        selectBox.startup();
    }

    private _loadGDPRSection() {

        if (this.hasUserRole("Addresses_GDPR")) {
            this.hideNode(this.GDPRSectionExpander, false);

            if (this.GDPRSectionWidget) {
                this.GDPRSectionWidget.destroy();
                this.GDPRSectionChangedData = null;
            }

            this.GDPRSectionWidget = new GDPRSection(this.entityId);
            this.GDPRSectionWidget.placeAt(this.GDPRSectionWidgetContainer);
            this.GDPRSectionWidget.on("GDPR_TableUpdate", (hasContent) => {
                this.GDPRSectionExpander.setMarking(hasContent ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
            })
            this.GDPRSectionWidget.on("GDPR_DataChanged", (data) => {
                this.GDPRSectionChangedData = data;
                this.allValues["GDPRData"] = data;
            });
        }
        else {

            this.hideNode(this.GDPRSectionExpander);
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //on(this.domNode, "click", function (evt) { evt.stopPropagation(); })

        if (this.hasFeature("Address/DivisionsSection")) this.UiModder.domClass.remove(this.divisionContainer, "w3-hide");
        this.organisation.enablePlainTextValue = false;

        this._getLanguages();

        //this.organisation.enableSelectEntityDialog(true);

        //this.addressCategory.isMandatory = true;
        //this.jobTitle._loadListValues();
        //this.contactFields.setBlankOption(null, "--", false);

        this.jobTitle.setEnablePlaintextValue(true);

        this.hasUserRole("dummy", lang.hitch(this, this._handlePrivileges));


        this.contactAndCommunicationTable = new contactDisplayTable();
        this.contactAndCommunicationTable.placeAt(this.contactWidgetContainer);
        this.contactAndCommunicationTable.on("contentChange", lang.hitch(this, this._onCommTableContentChange));
        this.contactAndCommunicationTable.on("requestCommunicationEditor", lang.hitch(this, this._onRequest_CommunicationEditor));
        this.on("saved", lang.hitch(this, this._onSaved_UpdateContactCommunicationData));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.addressCategory.loadListValues();

        this.UiModder.domClass.add(this.MusicianDataExpander.containerNode, "mediumTransparentBG");

    }
}

export default mdsWidget(ContactPersonForm);
